import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53086)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 19.8271H-0.000976562V30.1719H49.9989V19.8271Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.861131 8.62061H49.1369C49.613 8.62061 49.999 9.00664 49.999 9.48271V14.2241H-0.000976562V9.48271C-0.000976562 9.00664 0.385058 8.62061 0.861131 8.62061Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 14.2246H-0.000976562V19.8281H49.9989V14.2246Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1368 41.3794H0.861131C0.385058 41.3794 -0.000976562 40.9934 -0.000976562 40.5173V35.7759H49.9989V40.5173C49.9989 40.9934 49.6129 41.3794 49.1368 41.3794Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9984 30.1719H-0.00146484V35.7754H49.9984V30.1719Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5132 29.3105C15.7401 29.3105 17.5454 27.3806 17.5454 25C17.5454 22.6193 15.7401 20.6895 13.5132 20.6895C11.2862 20.6895 9.48096 22.6193 9.48096 25C9.48096 27.3806 11.2862 29.3105 13.5132 29.3105Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5995 23.332H11.4282V25.4177H15.5995V23.332Z",
					fill: "#3CC8FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.9848 24.5176L12.0324 24.9776L12.2197 24.5549L12.1229 25.0071L12.4318 24.6628L12.1998 25.0631L12.6001 24.8312L12.2559 25.1401L12.7081 25.0432L12.2853 25.2306L12.7454 25.2782L12.2853 25.3259L12.7081 25.5133L12.2559 25.4164L12.6001 25.7253L12.1998 25.4933L12.4318 25.8936L12.1229 25.5493L12.2197 26.0016L12.0324 25.5788L11.9848 26.0388L11.9371 25.5788L11.7497 26.0016L11.8466 25.5493L11.5377 25.8936L11.7695 25.4933L11.3693 25.7253L11.7137 25.4164L11.2613 25.5133L11.6842 25.3259L11.2241 25.2782L11.6842 25.2306L11.2613 25.0432L11.7137 25.1401L11.3693 24.8312L11.7695 25.0631L11.5377 24.6628L11.8466 25.0071L11.7497 24.5549L11.9371 24.9776L11.9848 24.5176Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.3483 28.3368H12.6799L11.1504 27.0853V25.2778H16.0169V27.0853L14.3483 28.3368Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.1827 24.7217H15.1826C15.1822 24.6836 15.1514 24.6529 15.1132 24.6529C15.075 24.6529 15.0443 24.6836 15.0437 24.7217H15.0435C15.0435 24.963 14.9037 25.2968 14.7322 25.5358C14.4928 25.2335 14.4027 24.8829 14.3687 24.6621C14.3525 24.5568 14.2388 24.4984 14.1435 24.5461C14.0976 24.5691 14.0666 24.6139 14.0588 24.6646C13.9523 25.3465 13.6309 25.6362 13.4227 25.7554C13.111 25.4541 13.0083 24.9665 12.9745 24.6782C12.9613 24.5661 12.8414 24.5019 12.7404 24.5523C12.7016 24.5717 12.6728 24.6067 12.6592 24.6481C12.223 25.9774 11.0112 26.1122 11.0112 26.1122V26.5293H15.8777V26.3903V26.2514V26.1124V25.9734V25.8345C15.3218 25.6949 15.1827 24.7217 15.1827 24.7217Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.8785 23.4703C15.3224 23.1922 15.3224 22.9142 15.3224 22.9142C15.3224 22.9142 14.6271 22.636 14.071 22.636C14.071 22.636 14.21 22.3579 13.932 22.3579C13.6539 22.3579 13.5149 22.3579 13.5149 22.3579C13.5149 22.3579 13.376 22.3579 13.0978 22.3579C12.8197 22.3579 12.9589 22.636 12.9589 22.636C12.4027 22.636 11.7075 22.9142 11.7075 22.9142C11.7075 22.9142 11.7075 23.1923 11.1514 23.4703C10.5952 23.7484 10.5952 24.3741 10.5952 24.3741C10.5952 24.4894 10.6887 24.5826 10.8037 24.5826C10.9189 24.5826 11.0122 24.4892 11.0122 24.3741C11.0122 24.3503 11.0073 24.3279 11 24.3066L11.0122 24.3046L12.4026 23.3313H13.515H14.6274L16.0179 24.3046L16.0301 24.3066C16.0227 24.3278 16.0179 24.3504 16.0179 24.3741C16.0179 24.4894 16.1113 24.5826 16.2264 24.5826C16.3414 24.5826 16.4348 24.4892 16.4348 24.3741C16.4347 24.374 16.4347 23.7483 15.8785 23.4703Z",
					fill: "#F0AA00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.2955 25.1387C16.1565 25.1387 15.7393 25.1387 15.7393 24.7216C15.7393 24.3045 16.2955 24.3045 16.2955 24.3045L15.4612 24.0264C15.1831 24.9996 15.7393 24.9996 15.7393 26.2511C15.7393 27.3721 14.488 28.0586 14.0708 28.0586C13.6537 28.0586 13.5146 28.3367 13.5146 28.3367C13.5146 28.3367 13.3757 28.0586 12.9585 28.0586C12.5414 28.0586 11.2899 27.3721 11.2899 26.2511C11.2899 24.9997 11.8461 24.9997 11.5681 24.0264L10.7338 24.3045C10.7338 24.3045 11.2899 24.3045 11.2899 24.7216C11.2899 25.1387 10.8728 25.1387 10.7338 25.1387C10.5947 25.1387 10.0386 25.1387 10.0386 25.8339C10.0386 26.5291 10.7338 27.3634 11.7071 27.9195C12.6804 28.4757 12.2633 29.0319 13.5146 29.0319C14.766 29.0319 14.3489 28.4758 15.3222 27.9195C16.2954 27.3634 16.9907 26.5291 16.9907 25.8339C16.9907 25.1387 16.4345 25.1387 16.2955 25.1387Z",
					fill: "#F0AA00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.2364 22.9627L12.9001 22.8115C12.8442 22.7864 12.7823 22.7806 12.7228 22.7944C12.506 22.8445 11.9682 23.0093 11.5679 23.4705L11.985 23.6095L13.2364 22.9627Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7925 22.9627L14.1288 22.8115C14.1847 22.7864 14.2466 22.7806 14.3062 22.7944C14.5229 22.8445 15.0607 23.0093 15.461 23.4705L15.0439 23.6095L13.7925 22.9627Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5636 23.0535L13.8171 22.8C13.8307 22.7864 13.8307 22.7645 13.8171 22.7509C13.8035 22.7373 13.7816 22.7373 13.768 22.7509L13.5145 23.0044L13.261 22.7509C13.2474 22.7373 13.2254 22.7373 13.2118 22.7509C13.1983 22.7645 13.1983 22.7864 13.2118 22.8L13.4654 23.0535L13.2118 23.3071C13.1983 23.3206 13.1983 23.3426 13.2118 23.3562C13.2187 23.363 13.2276 23.3664 13.2365 23.3664C13.2452 23.3664 13.2542 23.363 13.2611 23.3562L13.5146 23.1027L13.7681 23.3562C13.7749 23.363 13.7838 23.3664 13.7927 23.3664C13.8017 23.3664 13.8105 23.363 13.8173 23.3562C13.8309 23.3426 13.8309 23.3206 13.8173 23.3071L13.5636 23.0535Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.295 24.305C16.295 24.0685 16.0715 23.9662 15.8779 23.9218V23.8116C15.6162 23.787 15.47 23.6888 15.2163 23.5158C15.1185 23.4491 15.0077 23.3737 14.8738 23.2923C14.385 22.9953 14.0092 22.9524 13.7923 22.9628V23.1926H13.2361V22.9628C13.0192 22.9524 12.6435 22.9953 12.1546 23.2923C12.0208 23.3736 11.9099 23.4491 11.8121 23.5158C11.5583 23.6887 11.4123 23.787 11.1505 23.8116V23.9218C10.9568 23.9661 10.7334 24.0684 10.7334 24.305L11.1505 24.166V24.2294C11.5451 24.2003 11.7707 24.0489 12.047 23.8607C12.1406 23.797 12.2467 23.7246 12.3711 23.6491C12.6887 23.4561 12.9354 23.3964 13.0971 23.3823V23.6099H13.9313V23.3823C14.093 23.3965 14.3397 23.4561 14.6573 23.6491C14.7819 23.7248 14.8879 23.797 14.9814 23.8607C15.2576 24.0489 15.4833 24.2004 15.8779 24.2294V24.166L16.295 24.305Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.1826 22.1133V21.9412H14.7953C14.863 21.8831 14.9046 21.8147 14.9046 21.7327C14.9046 21.3485 14.0306 21.2461 13.5142 21.2461C12.9978 21.2461 12.1237 21.3485 12.1237 21.7327C12.1237 21.8147 12.1653 21.8831 12.233 21.9412H11.8457V22.1133C11.5053 22.1893 11.2271 22.3719 11.2124 22.3817L11.3666 22.6131C11.3704 22.6105 11.753 22.3583 12.1237 22.3583V22.2193H14.9046V22.3583C15.2754 22.3583 15.6579 22.6104 15.6617 22.6131L15.8159 22.3817C15.8014 22.3719 15.523 22.1893 15.1826 22.1133ZM14.0703 21.9027V21.7972C14.0703 21.7291 14.0063 21.6792 13.9403 21.6957L13.5142 21.8022L13.088 21.6957C13.022 21.6792 12.958 21.7291 12.958 21.7972V21.9027C12.6456 21.8568 12.4609 21.7805 12.4105 21.7327C12.4857 21.6612 12.8542 21.5242 13.5141 21.5242C14.1739 21.5242 14.5424 21.6614 14.6176 21.7327C14.5674 21.7804 14.3826 21.8567 14.0703 21.9027Z",
					fill: "#3CC8FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5313 23.6622L13.5665 23.7677L13.6775 23.7686C13.6919 23.7687 13.6979 23.7872 13.6863 23.7957L13.597 23.8619L13.6305 23.968C13.6348 23.9818 13.6192 23.9931 13.6075 23.9847L13.5171 23.92L13.4267 23.9847C13.415 23.9931 13.3994 23.9817 13.4037 23.968L13.4372 23.8619L13.3479 23.7957C13.3363 23.7872 13.3423 23.7687 13.3567 23.7686L13.4677 23.7677L13.5029 23.6622C13.5074 23.6484 13.5266 23.6484 13.5313 23.6622Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9862 23.6978L13.0322 23.7992L13.1428 23.7884C13.1571 23.787 13.1649 23.8047 13.1544 23.8144L13.0724 23.8896L13.1169 23.9916C13.1227 24.0049 13.1083 24.0178 13.0958 24.0107L12.9992 23.9558L12.9161 24.0297C12.9054 24.0393 12.8886 24.0296 12.8915 24.0155L12.9137 23.9063L12.8179 23.8499C12.8056 23.8426 12.8095 23.8238 12.8239 23.8221L12.9342 23.8096L12.9581 23.7009C12.961 23.6867 12.9803 23.6846 12.9862 23.6978Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.4265 23.8468L12.4933 23.9358L12.5989 23.9012C12.6125 23.8967 12.624 23.9123 12.6157 23.9241L12.552 24.0153L12.6175 24.1052C12.626 24.1168 12.6148 24.1325 12.601 24.1284L12.4949 24.0957L12.4297 24.186C12.4213 24.1976 12.4028 24.1918 12.4026 24.1775L12.4007 24.0661L12.295 24.0319C12.2814 24.0275 12.2812 24.008 12.2948 24.0034L12.3998 23.9672L12.3996 23.8559C12.3995 23.8415 12.4179 23.8353 12.4265 23.8468Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8659 24.0831L11.9439 24.1624L12.0439 24.1142C12.0569 24.1079 12.0703 24.1218 12.0637 24.1347L12.0125 24.2335L12.0893 24.314C12.0992 24.3244 12.0903 24.3414 12.076 24.3392L11.9664 24.321L11.9137 24.4191C11.9068 24.4318 11.8879 24.4284 11.8857 24.4142L11.8691 24.304L11.7599 24.2841C11.7456 24.2816 11.743 24.2623 11.7559 24.2559L11.8552 24.2061L11.8404 24.0957C11.8385 24.0814 11.8558 24.0729 11.8659 24.0831Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.0485 23.6978L14.0025 23.7992L13.8919 23.7884C13.8776 23.787 13.8698 23.8047 13.8803 23.8144L13.9623 23.8896L13.9178 23.9916C13.912 24.0049 13.9264 24.0178 13.9389 24.0107L14.0355 23.9558L14.1186 24.0297C14.1293 24.0393 14.1461 24.0296 14.1432 24.0155L14.121 23.9063L14.2168 23.8499C14.2292 23.8426 14.2252 23.8238 14.2108 23.8221L14.1005 23.8096L14.0766 23.7009C14.0736 23.6867 14.0543 23.6846 14.0485 23.6978Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.608 23.8468L14.5412 23.9358L14.4356 23.9012C14.422 23.8967 14.4105 23.9123 14.4188 23.9241L14.4825 24.0153L14.417 24.1052C14.4085 24.1168 14.4197 24.1325 14.4335 24.1284L14.5396 24.0957L14.6048 24.186C14.6132 24.1976 14.6317 24.1918 14.6319 24.1775L14.6338 24.0661L14.7395 24.0319C14.7531 24.0275 14.7533 24.008 14.7397 24.0034L14.6347 23.9672L14.6349 23.8559C14.635 23.8415 14.6166 23.8353 14.608 23.8468Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.169 24.0831L15.091 24.1624L14.991 24.1142C14.978 24.1079 14.9646 24.1218 14.9712 24.1347L15.0224 24.2335L14.9456 24.314C14.9357 24.3244 14.9446 24.3414 14.9589 24.3392L15.0685 24.321L15.1212 24.4191C15.1281 24.4318 15.147 24.4284 15.1492 24.4142L15.1657 24.304L15.275 24.2841C15.2893 24.2816 15.2919 24.2623 15.279 24.2559L15.1797 24.2061L15.1945 24.0957C15.1963 24.0814 15.179 24.0729 15.169 24.0831Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5537 26.9985L13.262 27.4721H14.118L14.5135 27.1332L14.2093 27.2549H13.2012L12.5537 26.9985Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.0353 26.3877L12.9671 27.0771L12.6567 26.9584C12.6567 26.9582 12.7995 26.626 13.0353 26.3877Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6949 26.1143H13.6489V27.2881H13.6949V26.1143Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.1207 26.2139H14.0747V27.2891H14.1207V26.2139Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.2721 26.2139H13.2261V27.2891H13.2721V26.2139Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.813 27.177H13.5328C13.5037 27.177 13.48 27.1532 13.48 27.124V26.9821C13.48 26.9529 13.5037 26.9292 13.5328 26.9292H13.813C13.8421 26.9292 13.8658 26.9529 13.8658 26.9821V27.124C13.8658 27.1532 13.8421 27.177 13.813 27.177Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.813 26.8469H13.5328C13.5037 26.8469 13.48 26.8231 13.48 26.7939V26.6521C13.48 26.6229 13.5037 26.5991 13.5328 26.5991H13.813C13.8421 26.5991 13.8658 26.6229 13.8658 26.6521V26.7939C13.8658 26.8232 13.8421 26.8469 13.813 26.8469Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.813 26.5427H13.5328C13.5037 26.5427 13.48 26.5189 13.48 26.4897V26.3479C13.48 26.3187 13.5037 26.2949 13.5328 26.2949H13.813C13.8421 26.2949 13.8658 26.3187 13.8658 26.3479V26.4897C13.8658 26.5189 13.8421 26.5427 13.813 26.5427Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2127 27.177H13.9844C13.9553 27.177 13.9316 27.1532 13.9316 27.124V26.9821C13.9316 26.9529 13.9553 26.9292 13.9844 26.9292H14.2127C14.2418 26.9292 14.2654 26.9529 14.2654 26.9821V27.124C14.2654 27.1532 14.2418 27.177 14.2127 27.177Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2127 26.8729H13.9844C13.9553 26.8729 13.9316 26.8492 13.9316 26.82V26.717C13.9316 26.6878 13.9553 26.6641 13.9844 26.6641H14.2127C14.2418 26.6641 14.2654 26.6878 14.2654 26.717V26.82C14.2654 26.8492 14.2418 26.8729 14.2127 26.8729Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2127 26.5719H13.9844C13.9553 26.5719 13.9316 26.5481 13.9316 26.5189V26.4494C13.9316 26.4202 13.9553 26.3965 13.9844 26.3965H14.2127C14.2418 26.3965 14.2654 26.4202 14.2654 26.4494V26.5189C14.2654 26.5481 14.2418 26.5719 14.2127 26.5719Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.363 27.177H13.1348C13.1057 27.177 13.082 27.1532 13.082 27.124V26.9821C13.082 26.9529 13.1057 26.9292 13.1348 26.9292H13.363C13.3922 26.9292 13.4158 26.9529 13.4158 26.9821V27.124C13.4157 27.1532 13.3922 27.177 13.363 27.177Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.363 26.8729H13.1348C13.1057 26.8729 13.082 26.8492 13.082 26.82V26.717C13.082 26.6878 13.1057 26.6641 13.1348 26.6641H13.363C13.3922 26.6641 13.4158 26.6878 13.4158 26.717V26.82C13.4157 26.8492 13.3922 26.8729 13.363 26.8729Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.363 26.5719H13.1348C13.1057 26.5719 13.082 26.5481 13.082 26.5189V26.4494C13.082 26.4202 13.1057 26.3965 13.1348 26.3965H13.363C13.3922 26.3965 13.4158 26.4202 13.4158 26.4494V26.5189C13.4157 26.5481 13.3922 26.5719 13.363 26.5719Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.272 26.2139V26.3528L13.4758 26.282L13.272 26.2139Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.1211 26.2139V26.3528L14.325 26.282L14.1211 26.2139Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6958 26.1143V26.2531L13.8998 26.1823L13.6958 26.1143Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.1528 25.1758L13.3988 25.3403H13.6963L13.8337 25.2226L13.7279 25.2647H13.3777L13.1528 25.1758Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.32 24.9634L13.2963 25.2029L13.1885 25.1616C13.1884 25.1616 13.2381 25.0462 13.32 24.9634Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5486 24.8682H13.5327V25.2761H13.5486V24.8682Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6961 24.9033H13.6802V25.2767H13.6961V24.9033Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4017 24.9033H13.3857V25.2767H13.4017V24.9033Z",
					fill: "#8C5A28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5894 25.2375H13.492C13.4819 25.2375 13.4736 25.2293 13.4736 25.219V25.1698C13.4736 25.1597 13.4818 25.1514 13.492 25.1514H13.5894C13.5996 25.1514 13.6079 25.1596 13.6079 25.1698V25.219C13.6079 25.2293 13.5997 25.2375 13.5894 25.2375Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5894 25.1228H13.492C13.4819 25.1228 13.4736 25.1146 13.4736 25.1043V25.0551C13.4736 25.0449 13.4818 25.0366 13.492 25.0366H13.5894C13.5996 25.0366 13.6079 25.0448 13.6079 25.0551V25.1043C13.6079 25.1145 13.5997 25.1228 13.5894 25.1228Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5894 25.0173H13.492C13.4819 25.0173 13.4736 25.0091 13.4736 24.9988V24.9496C13.4736 24.9395 13.4818 24.9312 13.492 24.9312H13.5894C13.5996 24.9312 13.6079 24.9394 13.6079 24.9496V24.9988C13.6079 25.0091 13.5997 25.0173 13.5894 25.0173Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7286 25.2375H13.6493C13.6391 25.2375 13.6309 25.2293 13.6309 25.219V25.1698C13.6309 25.1597 13.639 25.1514 13.6493 25.1514H13.7286C13.7387 25.1514 13.747 25.1596 13.747 25.1698V25.219C13.7469 25.2293 13.7386 25.2375 13.7286 25.2375Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7286 25.1322H13.6493C13.6391 25.1322 13.6309 25.124 13.6309 25.1138V25.078C13.6309 25.0679 13.639 25.0596 13.6493 25.0596H13.7286C13.7387 25.0596 13.747 25.0678 13.747 25.078V25.1138C13.7469 25.1241 13.7386 25.1322 13.7286 25.1322Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7286 25.0273H13.6493C13.6391 25.0273 13.6309 25.0191 13.6309 25.0089V24.9848C13.6309 24.9746 13.639 24.9663 13.6493 24.9663H13.7286C13.7387 24.9663 13.747 24.9745 13.747 24.9848V25.0089C13.7469 25.0192 13.7386 25.0273 13.7286 25.0273Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4331 25.2375H13.3539C13.3437 25.2375 13.3354 25.2293 13.3354 25.219V25.1698C13.3354 25.1597 13.3436 25.1514 13.3539 25.1514H13.4331C13.4433 25.1514 13.4516 25.1596 13.4516 25.1698V25.219C13.4515 25.2293 13.4433 25.2375 13.4331 25.2375Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4331 25.1322H13.3539C13.3437 25.1322 13.3354 25.124 13.3354 25.1138V25.078C13.3354 25.0679 13.3436 25.0596 13.3539 25.0596H13.4331C13.4433 25.0596 13.4516 25.0678 13.4516 25.078V25.1138C13.4515 25.1241 13.4433 25.1322 13.4331 25.1322Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4331 25.0273H13.3539C13.3437 25.0273 13.3354 25.0191 13.3354 25.0089V24.9848C13.3354 24.9746 13.3436 24.9663 13.3539 24.9663H13.4331C13.4433 24.9663 13.4516 24.9745 13.4516 24.9848V25.0089C13.4515 25.0192 13.4433 25.0273 13.4331 25.0273Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4019 24.9028V24.9511L13.4727 24.9266L13.4019 24.9028Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6968 24.9028V24.9511L13.7676 24.9266L13.6968 24.9028Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5488 24.8687V24.9168L13.6196 24.8922L13.5488 24.8687Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9785 24.4437H12.798C12.733 24.4437 12.6797 24.3905 12.6797 24.3254C12.6797 24.2604 12.7329 24.207 12.798 24.207H12.9785C13.0436 24.207 13.0969 24.2603 13.0969 24.3254C13.097 24.3905 13.0437 24.4437 12.9785 24.4437Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.3501 24.4437H14.2313C14.1662 24.4437 14.1133 24.3907 14.1133 24.3254C14.1133 24.2601 14.1662 24.207 14.2313 24.207H14.3501C14.4152 24.207 14.4681 24.2601 14.4681 24.3254C14.468 24.3907 14.4151 24.4437 14.3501 24.4437Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.1956 24.6217H15.0909C15.0536 24.6217 15.0234 24.5914 15.0234 24.554V24.5428C15.0234 24.5054 15.0536 24.4751 15.0909 24.4751H15.1956C15.2329 24.4751 15.2631 24.5054 15.2631 24.5428V24.554C15.2631 24.5914 15.2329 24.6217 15.1956 24.6217Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53086",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCrFlag);
export { ForwardRef as ReactComponent };
